import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ButtonLink } from '../ui/ButtonLink';
import { ImageSourceBadge } from '../ui/ImageSourceBadge';
import { ReviewNote } from '../ui/ReviewNote';
import { useProjectDrawer } from '../../contexts/ProjectDrawerContext';
import { getProjectById } from '../../data/projects';
import type { Project, Service } from '../../types/content';
export function ServiceSection({
  service,
  reversed
}: {
  service: Service;
  reversed: boolean;
}) {
  const {
    openProject
  } = useProjectDrawer();
  const related = service.relatedProjectIds.map(getProjectById).filter(Boolean) as Project[];
  return <section id={service.id} aria-labelledby={`${service.id}-title`} className={`scroll-mt-[140px] py-20 md:py-24 ${reversed ? 'bg-charcoal-950' : 'bg-charcoal'}`} data-id="element-426" data-mp="1ufn0e9t1q7tq">
      <div className="mx-auto grid max-w-site items-start gap-12 px-5 md:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-427" data-mp="3otecrh2rf5sv">
        <div className={`relative lg:sticky lg:top-[160px] ${reversed ? 'lg:order-2' : ''}`} data-id="element-428" data-mp="3tqo2kxu29jh8">
          <div className="relative aspect-[4/3] overflow-hidden" data-id="element-429" data-mp="1p7e75i93i4jy">
            <img src={service.image.src} alt={service.image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-430" data-mp="1l7vkagxprjeh" />
            <ImageSourceBadge source={service.image.source} className="absolute bottom-3 right-3" data-id="element-431" data-mp="1yy8rgh2s6u2r" />
          </div>
          <span className="absolute -bottom-2 left-0 h-2 w-1/3 bg-brand-red" aria-hidden="true" data-id="element-432" data-mp="1u1qrrvmb5lxa" />
        </div>

        <div data-id="element-433" data-mp="16bwfpg9tc1e3">
          <h2 id={`${service.id}-title`} className="font-display text-[40px] font-extrabold uppercase leading-[0.92] text-white md:text-[52px]" data-id="element-434" data-mp="128reri5ds7rk">
            {service.title}
          </h2>
          <p className="mt-6 text-[18px] leading-relaxed text-steel-200" data-id="element-435" data-mp="1b962eo5thyy8">{service.overview}</p>

          <h3 className="mt-10 font-display text-[18px] font-bold uppercase tracking-[0.12em] text-brand-light" data-id="element-436" data-mp="1bbirdl9zt9ks">Scope</h3>
          <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-437" data-mp="2mouprgmzgzzk">
            {service.scope.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-steel-100" data-id="element-438" data-mp="2upslnerour52">
                <span className="mt-2 h-2 w-2 shrink-0 bg-brand-red" aria-hidden="true" data-id="element-439" data-mp="2ypup9tgzhumz" />
                {item}
              </li>)}
          </ul>

          {service.reviewNote && <ReviewNote className="mt-6" data-id="element-440" data-mp="38ok1b5m78kvb">{service.reviewNote}</ReviewNote>}

          {related.length > 0 && <>
              <h3 className="mt-10 font-display text-[18px] font-bold uppercase tracking-[0.12em] text-brand-light" data-id="element-441" data-mp="2b235k4t46fbo">
                Related projects
              </h3>
              <ul className="mt-3 border-t border-white/10" data-id="element-442" data-mp="2kzhfrmog27vj">
                {related.map(project => <li key={project.id} className="border-b border-white/10" data-id="element-443" data-mp="2pqg3367uo68a">
                    <button type="button" onClick={event => openProject(project.id, event.currentTarget)} className="group flex w-full items-center justify-between gap-4 py-3.5 text-left" data-id="element-444" data-mp="1sajztq7pgn5y">
                      <span data-id="element-445" data-mp="1po1fvaww8wez">
                        <span className="block text-[16px] font-semibold text-white group-hover:text-brand-light" data-id="element-446" data-mp="1krass3mo90k2">{project.title}</span>
                        {project.location && <span className="block text-sm text-steel-400" data-id="element-447" data-mp="1fq3km3gm9zcv">{project.location}</span>}
                      </span>
                      <ArrowRightIcon className="h-4 w-4 shrink-0 text-steel-300 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-448" data-mp="16r9pyimujj1y" />
                    </button>
                  </li>)}
              </ul>
            </>}

          <ButtonLink to={`/contact?service=${service.id}#enquiry`} showArrow className="mt-10" data-id="element-449" data-mp="wzcfxf7kqx4t">
            Discuss This Service
          </ButtonLink>
        </div>
      </div>
    </section>;
}